import NavLeft from '../nav-main/src/v2/nav-left';

/* istanbul ignore next */
NavLeft.install = function(Vue) {
  Vue.component(NavLeft.name, NavLeft);
};

export default NavLeft;
